import { render, staticRenderFns } from "./AdminBadges.vue?vue&type=template&id=7ca46c06&scoped=true&"
import script from "./AdminBadges.vue?vue&type=script&lang=js&"
export * from "./AdminBadges.vue?vue&type=script&lang=js&"
import style0 from "./AdminBadges.vue?vue&type=style&index=0&id=7ca46c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca46c06",
  null
  
)

export default component.exports